const SCREEN = {
  UNAUTHENTICATED_BILL: 'Unauthenticated bill',
  UNAUTHENTICATED_PAID_BILL: 'Unauthenticated paid bill',
  UNAUTHENTICATED_FAMILYMART_SETTLEMENT:
    'Unauthenticated FamilyMart Settlement',
  UNAUTHENTICATED_LAWSON_MINISTOP_SETTLEMENT:
    'Unauthenticated Lawson Ministop Settlement',
  UNAUTHENTICATED_SEICOMART_SETTLEMENT: 'Unauthenticated Seicomart Settlement',
  UNAUTHENTICATED_VAN_SETTLEMENT: 'Unauthenticated VAN settlement',
  UNAUTHENTICATED_VAN_ERROR: 'Unauthenticated VAN error',
  UNAUTHENTICATED_BILL_UNAVAILABLE: 'Unauthenticated bill unavailable',
};

const ACTION = {
  PAGE_VIEW: 'Page View',
};

export { ACTION, SCREEN };
